import { render, staticRenderFns } from "./form-point-drawer.vue?vue&type=template&id=29ed51aa"
import script from "./form-point-drawer.vue?vue&type=script&lang=js"
export * from "./form-point-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports